import { createContext, useContext } from 'react';

export interface AuthReadyContextValue {
  authReady: boolean;
}

export const AuthReadyContext = createContext<AuthReadyContextValue | undefined>(undefined);

export const useAuthReady = () => {
  const context = useContext(AuthReadyContext);

  if (context === undefined) {
    throw new Error('useAuthReady must be used within an AuthReadyProvider');
  }

  return context;
};
